<template>
  <!-- 增加了拖拽、复制粘贴、调整大小、滚动吸顶 -->
  <div>
    <!-- element upload -->
    <el-row v-loading="quillUpdateImg">
      <div>
        <quill-editor v-model="content"
                      ref="myQuillEditor"
                      :options="editorOption"
                      @input="modelContent"
                      @change="onEditorChange($event)"
                      @blur="onEditorBlur($event)"
                      @focus="onEditorFocus($event)"
                      @ready="onEditorReady($event)"></quill-editor>
      </div>
    </el-row>
  </div>
</template>

<script>
// 修改 对其方式 ，quill 提供三种对其方式：1，style 2.class 3.ql-class
let Align = Quill.import('attributors/style/align')
Align.whitelist = ['right', 'center', 'justify']
Quill.register(Align, true)

let Size = Quill.import('attributors/style/size')
Size.whitelist = [
  '9px',
  '10px',
  false,
  '12px',
  '13px',
  '14px',
  '15px',
  '16px',
  '17px',
  '18px',
  '19px',
  '20px',
]
Quill.register(Size, true)
// import { quillEditor, Quill } from "vue-quill-editor";
import {
  container,
  ImageExtend,
  QuillWatch,
} from 'quill-image-super-solution-module'
import imageResize from 'quill-image-resize-module'
Quill.register('modules/ImageExtend', ImageExtend)
Quill.register('modules/ImageResize', imageResize)

export default {
  name: 'editor-v2',
  // components: { quillEditor },
  data() {
    return {
      content: this.editor_content, // 富文本内容
      quillUpdateImg: false,
      editorOption: {
        // 覆盖编辑器的 配置项
        placeholder: '',
        theme: this.selectTheme, // or 'bubble'
        modules: {
          ImageResize: {},
          ImageExtend: {
            loading: true, // 是否显示加载信息
            name: 'image',
            size: 10, // 可选参数 图片大小，单位为M，1M = 1024kb
            action: this.upLoadImgAddress,
            accept:
              'image/jpg, image/png, image/gif, image/jpeg, image/bmp, image/x-icon',
            // 服务端上传成功后返回结果
            response: (res) => {
              console.log(res)
              if (res.errno == '0') {
                return res.data.image_url
              } else {
                this.$message({
                  message: res.errmsg,
                  type: 'error',
                })
              }
            },
          },
          toolbar: {
            container: container, // 配置工具栏
            handlers: {
              image: function () {
                QuillWatch.emit(this.quill.id)
              },
            },
          },
        },
      },
    }
  },
  created() {
    // 图标
    this.editorOption.initButton = function () {
      // 在使用的页面中初始化按钮样式
      const revokeButton = document.querySelector('.ql-revoke')
      revokeButton.style.cssText = 'width:28px;height:24px;padding:2px 4px'
      revokeButton.innerHTML =
        '<img style="width:18.4px;height:18.4px" src="' + +'" />'

      const restoreButton = document.querySelector('.ql-restore')
      restoreButton.parentNode.style.cssText = 'float:right;margin-right:0'
      restoreButton.style.cssText =
        'height:24px;color:#3B80FC;cursor:pointer;width:80px;text-align:center;'
      restoreButton.innerHTML = '一键恢复'
    }
  },
  mounted() {
    this.editorOption.initButton && this.editorOption.initButton()
  },
  props: {
    upLoadImgAddress: {
      type: String,
      default: 'http://117.50.64.252:3344/add_image',
    },
    // 传过来的内容
    editor_content: {
      type: String,
      default: '',
    },
    // 编辑器工具栏是否吸顶：0不吸顶， 其他数字代表滚动到某个值时吸顶。也可以通过样式直接吸顶
    stickToolbar: {
      type: Number,
      default: 0,
    },
    // 自定义属性:编辑器主题
    selectTheme: {
      type: String,
      default: 'snow',
      // bubble\snow
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },

  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    modelContent(content) {
      // console.log("文本框有变化");
      // console.log(this.introduce);
      // console.log(content);
      this.$emit('content_change', content)
      // this.introduce = event.traget.value;
    },
    // ------滚动吸顶------
    handleScroll() {
      // 得到页面滚动的距离
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      // console.log(scrollTop);

      // 编辑器的工具栏
      let toolbar_obj = document.getElementsByClassName('ql-toolbar')
      let content_obj = document.getElementsByClassName('ql-editor')
      // console.log("style的长度");
      // 编辑器的 宽度
      // console.log(content_obj[0].offsetWidth);
      // console.log(toolbar_obj);
      // console.log(this.stickToolbar);
      if (toolbar_obj.length !== 0) {
        if (this.stickToolbar == 0) {
          // console.log("不执行滚动置顶");
        } else if (scrollTop > this.stickToolbar) {
          // console.log("页面滚动的距离 大于设定的距离");
          if (toolbar_obj[0].length !== 0) {
            toolbar_obj[0].style.float = 'center'
            toolbar_obj[0].style.position = 'fixed'
            toolbar_obj[0].style.width =
              document.getElementsByClassName('ql-editor')[0].offsetWidth + 'px'
            toolbar_obj[0].style.zIndex = '100'
            toolbar_obj[0].style.top = '0'
          }
        } else if (scrollTop < this.stickToolbar) {
          if (toolbar_obj[0].length !== 0) {
            toolbar_obj[0].style.position = ''
            toolbar_obj[0].style.zIndex = ''
            toolbar_obj[0].style.top = ''
          }
        }
      }
    },
    // ------编辑器自身事件------
    onEditorChange(value) {
      // console.log("change:监听内容编号");
      // console.log(value);
    },
    onEditorBlur(value) {
      // console.log("blur:失去光标");
      // console.log(value);
    },
    onEditorFocus(value) {
      // console.log("focus:出现光标");
      // console.log(value);
    },
    onEditorReady(value) {
      console.log('ready:')
    },
  },
}
</script>

<style>
img {
  width: 100%;
}
</style>